import { Box, Container, Stack } from "@mui/material";
import React from "react";

import Header from "../Header";
import ProductItem from "../ProductItem";
import SectionLayout from "../../layouts/SectionLayout";

import useContent from "../../hooks/useContent";
import { MAIN_ROUTES } from "../../utils/routes";

import { styles } from "./style";

const Products = () => {
  const content = useContent();

  return (
    <Box sx={styles.productRoot}>
      <SectionLayout id={MAIN_ROUTES.get("PRODUCTS").ID}>
        <Container maxWidth="md">
          <Header center data={content.products} />
        </Container>

        <Stack
          spacing={3}
          sx={{
            pb: { md: 12 },
            pt: { md: 12 },
          }}
        >
          {content.products?.items.map((item, index) => {
            return (
              <Box key={index}>
                <ProductItem
                  data={item}
                  direction={index % 2 === 0 ? "row-reverse" : "row"}
                />
              </Box>
            );
          })}
        </Stack>
      </SectionLayout>
    </Box>
  );
};

export default Products;
